// @ts-nocheck
import { useEffect, useState } from "react";
import api from "../../../services/api";

// Emissões do cliente (aba Emissões), buscadas uma vez por carregamento da
// página e compartilhadas entre os cards — servem para o aviso "Também com
// você". Falha na busca não atrapalha o card: só some o aviso.
let pedido = null;

export function useEmissoes(ativo) {
  const [emissoes, setEmissoes] = useState([]);

  useEffect(() => {
    if (!ativo) return undefined;
    let vivo = true;
    if (!pedido) {
      pedido = api
        .get("central/emissoes")
        .then((r) => r?.data?.emissoes || [])
        .catch(() => {
          pedido = null;
          return [];
        });
    }
    pedido.then((lista) => vivo && setEmissoes(lista));
    return () => {
      vivo = false;
    };
  }, [ativo]);

  return emissoes;
}
